// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-icon {
  position: absolute;
  top: -1px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/show-article-dialog/show-article-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;AACF","sourcesContent":["mat-icon {\n  position: absolute;\n  top: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
